// refreshAzureToken
import { getCurrentAzureToken, refreshAzureToken } from "@/service/azure";
export default {
  name: "AppDetailTabAzure",
  data() {
    return {
      showDatePicker: false,
      token: "",
      expireAt: "",
      expireAt1: "",
      plaintext: false,
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        }
      }
    };
  },
  methods: {
    onError() {
      this.$Message.error($t("bktvvh4", "复制失败"));
    },
    // 复制
    onCopy() {
      this.$Message.success($t("bkv2mw4", "复制成功"));
    },
    setTime(e) {
      this.expireAt1 = e;
    },
    hideToken() {
      if (this.token) {
        if (this.token.indexOf("*") > -1) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    showToken(plaintext) {
      this.plaintext = plaintext;
      this.getToken();
    },
    async refreshToken() {
      if (this.expireAt1 == "") {
        return this.$Message.error($t("hzq1vh9", "请选择密钥到期时间"));
      }
      const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const res = await refreshAzureToken({
        expireAt: `${this.expireAt1} 00:00:00`,
        timeZone: timeZone
      });
      if (res.data.result === 0) {
        this.token = res.data.retVal;
        this.expireAt = this.expireAt1;
        this.$Message.success($t("deua4r4", "更新成功"));
      }
    },
    async getToken() {
      const res = await getCurrentAzureToken({
        plaintext: this.plaintext
      });
      if (res.data.result === 0) {
        this.token = res.data.retVal.value;
        this.expireAt = res.data.retVal.expireAt.split(" ")[0];
      }
    }
  },
  mounted() {
    this.getToken();
  }
};